module.exports = __webpack_public_path__ + "assets/img/coin-gct.8606a007.png";